import React from 'react';
import Loading from 'swag-client-common/components/info/loading';
import classNames from './custom-ink-footer.module.scss';
export const CustomInkFooter = ({
  isLoaded
}) => {
  if (!isLoaded) {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames.loading
    }, /*#__PURE__*/React.createElement(Loading, {
      isShown: true
    }));
  }
  return /*#__PURE__*/React.createElement("ci-footer", null);
};